import React, { useState } from 'react'

const NewsletterTwo = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null); // 'success' | 'error' | null
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;

        setLoading(true);
        setStatus(null);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/newsletter/subscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim() }),
            });
            const data = await res.json();
            setMessage(data.message || data.error);
            setStatus(res.ok ? 'success' : 'error');
            if (res.ok) setEmail('');
        } catch {
            setStatus('error');
            setMessage('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="newsletter-two py-40" style={{ background: 'linear-gradient(135deg, #1a3a6b 0%, #2575fc 100%)' }}>
            <style>{`
                .newsletter-two__form input::placeholder { color: rgba(255,255,255,0.6); }
                .newsletter-two__form input { background: rgba(255,255,255,0.12) !important; border: 1px solid rgba(255,255,255,0.25) !important; color: #fff !important; border-radius: 10px !important; }
                .newsletter-two__form input:focus { background: rgba(255,255,255,0.18) !important; border-color: rgba(255,255,255,0.5) !important; outline: none !important; box-shadow: none !important; }
                .newsletter-submit-btn { background: #fff !important; color: #1a3a6b !important; font-weight: 700 !important; border-radius: 10px !important; border: none !important; padding: 14px 24px !important; transition: opacity 0.15s, transform 0.1s !important; cursor: pointer; }
                .newsletter-submit-btn:hover { opacity: 0.9 !important; transform: translateY(-1px) !important; }
                .newsletter-submit-btn:disabled { opacity: 0.6 !important; cursor: not-allowed !important; transform: none !important; }
                .newsletter-icon-wrap { width: 48px; height: 48px; background: rgba(255,255,255,0.15); border-radius: 12px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
            `}</style>
            <div className="container container-lg">
                <div className="flex-between gap-20 flex-wrap">
                    <div className="flex-align gap-18">
                        <div className="newsletter-icon-wrap">
                            <i className="ph ph-envelope-simple" style={{ fontSize: 22, color: '#fff' }} />
                        </div>
                        <div>
                            <h5 className="text-white mb-6 fw-bold" style={{ fontSize: 18, letterSpacing: '-0.2px' }}>
                                Join Our Newsletter
                            </h5>
                            <p className="mb-0" style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.75)', fontWeight: 400 }}>
                                Get the latest deals, events, and exclusive offers
                            </p>
                        </div>
                    </div>
                    <div className="w-50">
                        <form onSubmit={handleSubmit} className="newsletter-two__form">
                            <div className="flex-align gap-12">
                                <input
                                    type="email"
                                    className="common-input style-two flex-grow-1 py-14"
                                    placeholder="Enter your email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <button type="submit" className="newsletter-submit-btn flex-shrink-0" disabled={loading}>
                                    {loading ? 'Subscribing...' : 'Subscribe'}
                                </button>
                            </div>
                        </form>
                        {status && (
                            <p style={{
                                marginTop: 8,
                                fontSize: 13,
                                fontWeight: 500,
                                color: status === 'success' ? '#a8f0c6' : '#fca5a5',
                            }}>
                                {message}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewsletterTwo
